module.exports = __webpack_public_path__ + "static/media/vf_wearring_core.420d4aa6.svg";